export type Volume = {
  number: string
  title: string
  /** "Sessions 1.01–1.21 · preseason" */
  range: string
  promise: string
  contents: string[]
  /** Badge colour for the volume number (the event-group colour) */
  badge: string
  flag?: string
}

/** The six volumes, in the order the season is coached. */
export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Day One Ready',
    range: '21 sessions · preseason, whole team',
    promise:
      'Build the Fence Card System and run your first two weeks day by day, before you know who belongs in which event group.',
    badge: 'bg-navy text-chalk ring-1 ring-navy-line',
    flag: 'Start here',
    contents: [
      'The Fence Card System: how one coach runs five event groups at once',
      'The 4-Phase Season Map: Foundation, Build, Compete, Peak',
      'Days 1–10 planned, including the event sampler and a baseline time trial',
      'The First-Week Sort: place every athlete in an event group',
      '40+ athletes and one coach: the 6-station circuit and a gym-only practice',
    ],
  },
  {
    number: '02',
    title: 'Speed Ready',
    range: '22 sessions · sprints, hurdles, relays',
    promise:
      'Acceleration, top speed and speed endurance, then hurdles and relay exchanges, from Foundation to Peak.',
    badge: 'bg-clay text-white',
    contents: [
      'The Speed Ladder: acceleration, then top speed, then speed endurance',
      'Starting blocks set in 2 minutes with the foot-length method',
      'The 3-Step Rhythm Builder for hurdles (coach-supervised)',
      'The Relay Zone Check: go-mark, call, hand, hold',
    ],
  },
  {
    number: '03',
    title: 'Jumps Ready',
    range: '20 sessions · long, triple, high jump',
    promise:
      'One repeatable run-up for every jumper, then long jump, triple jump and high jump from first day to meet day.',
    badge: 'bg-amber text-hl-ink',
    contents: [
      'The Jumps Safety Gate: the 2-minute check before anyone jumps',
      'The Approach Anchor and the approach card for every jumper',
      'The Even-Rhythm Triple: hop, step, jump without collapsing',
      'The J-Curve Approach: scissors to back layout (coach-supervised)',
    ],
  },
  {
    number: '04',
    title: 'Throws Ready',
    range: '21 sessions · shot put, discus, javelin',
    promise:
      'Standing throws before full technique, every implement session coach-supervised, step by step.',
    badge: 'bg-infield text-white',
    contents: [
      'The Throws Safety Circle: throw on command, retrieve on command',
      'The Stand-Turn-Throw Progression for shot put and discus',
      'Javelin with youth training javelins, where it’s contested',
      'Med-ball sessions for days the ring is unavailable',
    ],
  },
  {
    number: '05',
    title: 'Distance Ready',
    range: '21 sessions · 800m to 3200m',
    promise:
      'Aerobic base runners keep showing up for, then event sessions for the 800, 1600 and 3200, paced and planned.',
    badge: 'bg-lane text-white',
    contents: [
      'The Pace Grid: 5 effort zones runners feel with the talk test',
      'The Hard-Easy Rhythm: how to arrange a distance week',
      'Training paces from one time trial',
      'The Race Plan Card: start, settle, move, kick',
    ],
  },
  {
    number: '06',
    title: 'Meet Season Ready',
    range: '16 sessions · meet weeks & championship',
    promise:
      'Two-meet weeks, meet day from bus to last relay, and a championship phase that leaves legs fresh.',
    badge: 'bg-navy text-chalk ring-1 ring-navy-line',
    contents: [
      'The Two-Meet Week Planner: what every group does every day',
      'The Meet Day Game Plan: arrive, set camp, check in, warm up, compete',
      'The Sharpen Phase: less volume, same quality',
      'Weather cancellations, half the team away, senior night',
    ],
  },
]
